export const guibil_api_tr = {
  error: {
    title: 'Hata oluştu!',
    message: 'Hata oluştu, servis bağlantılarınızı kontrol ediniz',
  },
};
